"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _ListContext = _interopRequireDefault(require("./contexts/ListContext"));
var _types = require("../ListItem/types");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var getChildByIndex = function getChildByIndex(children, index) {
  var items = _react.Children.toArray(children);
  if (items && items.length) {
    return items[index];
  }
};
var List = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = props.type,
    type = _a === void 0 ? _types.ListItemTypes.Normal : _a,
    _b = props.allowKeyboardNavigation,
    allowKeyboardNavigation = _b === void 0 ? true : _b,
    children = props.children,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onSelect = props.onSelect,
    DOMProps = __rest(props, ["type", "allowKeyboardNavigation", "children", "onKeyDown", "onFocus", "onBlur", "onSelect"]);
  var wrapperRef = (0, _react.useRef)(null);
  var targetedIndexRef = (0, _react.useRef)(-1);
  var _c = (0, _react.useState)(false),
    isFocused = _c[0],
    setIsFocused = _c[1];
  var _d = (0, _react.useState)(-1),
    targetedIndex = _d[0],
    setTargetedIndex = _d[1];
  var getPreviousIndex = (0, _react.useCallback)(function (index) {
    var nextIndex = index - 1;
    if (nextIndex < 0) {
      nextIndex = 0;
    }
    return nextIndex;
  }, []);
  var handleOnSelect = (0, _react.useCallback)(function () {
    if (isFocused && typeof onSelect === 'function') {
      var targetedChild = getChildByIndex(children, targetedIndexRef.current);
      if (targetedChild && (targetedChild === null || targetedChild === void 0 ? void 0 : targetedChild.props.value)) {
        onSelect(targetedChild.props.value);
      }
    }
  }, [isFocused, onSelect, children]);
  var getNextIndex = (0, _react.useCallback)(function (index) {
    var nextIndex = index + 1;
    if (nextIndex > _react.Children.count(children) - 1) {
      nextIndex = _react.Children.count(children) - 1;
    }
    return nextIndex;
  }, [children]);
  var handleOnArrowUp = (0, _react.useCallback)(function () {
    setTargetedIndex(function (current) {
      return getPreviousIndex(current);
    });
  }, [getPreviousIndex]);
  var handleOnArrowDown = (0, _react.useCallback)(function () {
    setTargetedIndex(function (current) {
      return getNextIndex(current);
    });
  }, [getNextIndex]);
  var hadnleOnKeyDown = (0, _react.useCallback)(function (event) {
    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
    }
    if (allowKeyboardNavigation) {
      setIsFocused(true);
      switch (event.code) {
        case 'ArrowUp':
          {
            event.preventDefault();
            event.stopPropagation();
            handleOnArrowUp();
            break;
          }
        case 'ArrowDown':
          {
            event.preventDefault();
            event.stopPropagation();
            handleOnArrowDown();
            break;
          }
        case 'Enter':
        case 'Space':
          {
            event.preventDefault();
            event.stopPropagation();
            handleOnSelect();
            break;
          }
      }
    }
  }, [onKeyDown, allowKeyboardNavigation, handleOnArrowUp, handleOnArrowDown, handleOnSelect]);
  (0, _react.useImperativeHandle)(ref, function () {
    var listRef = wrapperRef.current;
    listRef.isFocused = isFocused;
    listRef.setFocus = function (focused) {
      return setIsFocused(focused);
    };
    listRef.handleOnKeyDown = hadnleOnKeyDown;
    return listRef;
  }, [isFocused, hadnleOnKeyDown]);
  (0, _react.useEffect)(function () {
    targetedIndexRef.current = targetedIndex;
  }, [targetedIndex]);
  var handleOnFocus = (0, _react.useCallback)(function (event) {
    if (typeof onFocus === 'function') {
      onFocus(event);
    }
    setIsFocused(true);
  }, [onFocus]);
  var handleOnBlur = (0, _react.useCallback)(function (event) {
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
    setIsFocused(false);
  }, [onBlur]);
  var context = {
    _domRef: wrapperRef
  };
  return (0, _jsxRuntime.jsx)(_ListContext.default.Provider, __assign({
    value: context
  }, {
    children: (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
      ref: wrapperRef,
      tabIndex: 0,
      onKeyDown: hadnleOnKeyDown,
      onFocus: handleOnFocus,
      onBlur: handleOnBlur
    }, DOMProps, {
      children: _react.Children.map(children, function (child, idx) {
        if (child) {
          var childElement = child;
          var childProps = __assign({
            type: type,
            targeted: isFocused && targetedIndex === idx,
            onSelect: onSelect
          }, childElement.props);
          return /*#__PURE__*/(0, _react.cloneElement)(childElement, childProps);
        } else {
          return null;
        }
      })
    }))
  }));
});
List.displayName = 'List';
var _default = List;
exports.default = _default;